import { useEffect, useState } from "react";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { CardTaps } from "../../theme/Component/CardTaps";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem, _Inbox, _single } from "../../../core/services/dataBean/EntityCatalog";
import { SelectFunctionalID } from "../../admin/configuracion/functionalID/SelectFunctionalID";
import { ModalGeneric } from "../../../interfaces";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Alert } from "../../theme/Component/Alert";
import { BPMVerifyInboxAssigned } from "./BPMVerifyInboxAssigned";
import { SelectGroupMemberAssigned } from "../../theme/Component/SelectGroupMemberAssigned";
import { MODAL_LG } from "../../theme/Component/hooks/useModal";
import { HandlerInfoProcess } from "../config/InfoTramiteComponents/HandlerInfoProcess";
import { toast } from "react-toastify";
import usePaginator from "../../theme/Component/usePaginator";
import { SelectGroupMemberTable } from "../BpmInbox/SelectGroupMember/SelectGroupMemberTable";
import { BPMRequestProcedureType } from "../RequestProcedure/BPMRequestProcedureType";

interface Props {
    isAdmin?: boolean;
}
export const BPMVerifyInbox = ({ isAdmin }: Props) => {

    // const testMode = env.PRINT_LOG ?? false;
    const testMode = isAdmin ?? false;
    const paginador = usePaginator();
    const { instance, lista, setLista, bean, setBean } = useDataBean(_Inbox);
    const [area, setArea] = useState<any>({});
    const [indexTap, setIndexTap] = useState(0);
    const [asignedRolID, setAsignedRolID] = useState([]);
    const [user, setUser] = useState<any>({});
    const [obs, setObs] = useState<string>("");

    const [modalAutoAssing, setModalAutoAssing] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalHistory, setModalHistory] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: MODAL_LG });
    const [modalAssing, setModalAssing] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalReques, setModalRequest] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalCancel, setModalCancel] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });


    let taps = [
        { id: 0, name: 'Sin Asignar', disable: (!area.IDLn) },
        { id: 1, name: 'Por Gestión', disable: (!area.IDLn) }
    ];

    const [isBoss, setISBoss] = useState<boolean>(false)

    useEffect(() => {
        setLista([]);
        setISBoss(_single.getIDBossGroupAssingned(area?.IDLn) === _single.getAccountID())

        getRoles();

    }, [])

    useEffect(() => {
        getLista()
    }, [area.IDLn, paginador.page, indexTap])

    useEffect(() => {

        if (asignedRolID.length > 0 || testMode || isBoss) {
            getLista()
        }
    }, [indexTap, asignedRolID])

    const renderUserInfo = (item: any) => {
        let render =
            ` 
        <div>            
            <strong>NIT: </strong><small>${item.DataBeanProperties.AccountID ? item.DataBeanProperties.AccountID : 'NA'}</small><br />
            <strong>Usuario: </strong><small>${item.DataBeanProperties.AccountName ? item.DataBeanProperties.AccountName : 'NA'}</small><br />
            <strong>Télefono: </strong><small>${item.DataBeanProperties.CelPhoneNumber ? item.DataBeanProperties.CelPhoneNumber : 'NA'}</small><br />
        </div>
        `
        return render;
    }

    const getLista = () => {
        if (area.IDWorkGroupMember) {
            instance.getProcedureImpForAssignVerifyWorkMember(area.IDWorkGroupMember, paginador.page, 15).then(
                (resp) => {
                    paginador.setPages(resp.NumberOfPages);

                    let x = resp.List;
                    x.forEach(element => {
                        element.DataBeanProperties.InfoUser = renderUserInfo(element)
                    });

                    setLista(x);
                }
            ).catch(
                err => { console.log(err) }
            )
        }
    }

    const getRoles = () => {
        instance.getWorkGroupRoleCatalog(area.IDWorkGroupMember).then(
            (resp) => {
                let list = [];
                let x = resp;
                x.map((item) => {
                    list.push(item.DataBeanProperties.IDBusinessRole)
                })
                setAsignedRolID(list)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const assingProcedure = (idaccount: number) => {
        instance.assignProcedureImpToGroupMember(bean.IDProcedureImp, idaccount, _single.getAccountID()).then(
            (resp) => {
                getLista();
                setModalAssing({ ...modalAssing, "view": false });
                setModalAutoAssing({ ...modalAutoAssing, "view": false });
            }
        )
    }

    const head = [
        { title: 'Tramite', property: 'AlphaCode', visible: true },
        { title: 'Procedimiento', property: 'ProcedureName', visible: true },
        { title: 'Soliocitante', property: 'InfoUser', visible: true },
        { title: 'Jusitificación Solicitud', property: 'Description', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Historico', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalHistory({ ...modalHistory, "view": true, "name": "Historico del Procedimiento" }) } },
            { titulo: 'Auto Asignar', icono: 'ri-user-follow-line', visible: (bean.IDAccountAction ? false : true), evento: () => { setModalAutoAssing({ ...modalAutoAssing, "view": true, "name": "AutoAsignar el Procedimiento" }) } },
            { titulo: 'Asignar a alguien', icono: 'ri-team-line', visible: isBoss && bean.IDAccountAction ? false : true, evento: () => { setModalAssing({ ...modalAssing, "view": true, "name": "Asignar procedimiento" }) } },
            { titulo: 'Cancelar Tramite', icono: 'ri-close-circle-line', visible: isBoss && bean.IDAccountAction ? false : true, evento: () => { setModalCancel({ ...modalCancel, "view": true, "name": "Confirmar Cancelación del tramite" }); setObs("") } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        // { nombre: 'Solicitar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { setModalRequest({ ...modalReques, view: true, name: "Nueva Solicitud" }) } }
    ]

    const deleteProcedureImp = () => {
        instance.cancelProcedureImp(bean.IDProcedureImp, _single.getAccountID(), obs).then(
            (resp: any) => {
                toast.success("Se ha realizado la accion");
                getLista();
                setModalCancel({ ...modalCancel, "view": false });
                pushResumeInfo(obs)
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("No se pudo realizar la acción")
            }
        )
    }

    const pushResumeInfo = (objeto: any) => {
        instance.pushResumeBpm(bean.IDProcedureImp, _single.getAccountID(), `${objeto} - Paso de Cancelación: ${bean.ProcedureStep}`, { disableSpinner: true }).then(
            (resp) => {
                setObs("");
            }
        ).catch(err => { console.log("Error en actualizar la tabla", err) })
    }

    return (
        <BasicPage titulo={`Bandeja de Verificación`}>
            {/* <PrintJson json={area} /> */}
            <div className="row">
                {testMode ?
                    <div className="col-md-6">
                        <SelectFunctionalID functionalIDLn={area?.IDLn} label="Area" onChange={(area: any) => { setArea(area) }} />
                    </div>
                    :
                    <div className="col-md-6">
                        <SelectGroupMemberAssigned idSelector={area?.IDLn} onChange={(area: any) => { setArea(area ?? null) }} returnType="Object" />
                    </div>
                }
                <div className="col-md-12">
                    <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >

                        {indexTap === 0 &&
                            <div className="row">
                                {area?.IDLn ?
                                    <div className="col-md-12">
                                        <BasicTable iconButtons={iconButtonsItem} body={lista} head={head} rowSet={setBean} listButtons={listaBotones()}
                                            pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                                        />
                                    </div>
                                    :
                                    <div className="row">
                                        <div className="col-md-12 text-center">
                                            <Alert children={"No se encuentra asignado a un area"} clase="danger" />
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        {indexTap === 1 &&
                            <div className="row">
                                <div className="col-md-12">
                                    <BPMVerifyInboxAssigned />
                                </div>
                            </div>
                        }
                    </CardTaps>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalHistory} updateModal={setModalHistory} >
                        <HandlerInfoProcess _ProcedureIMPID={bean.IDProcedureImp} />
                    </Modal>
                </div>

                <div className="col-md-12">
                    <ModalConfirm modal={modalAutoAssing} updateModal={setModalAutoAssing} eventModal={() => { assingProcedure(_single.getAccountID()) }}>
                        <p>¿Esta seguro de Asignarse el procedimiento {bean.AlphaCode}?</p>
                    </ModalConfirm>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalAssing} updateModal={setModalAssing} eventModal={() => {
                        assingProcedure(user.IDAccount)
                    }} >
                        <SelectGroupMemberTable idlnArea={area?.IDLn} onChange={setUser} />
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalReques} updateModal={setModalRequest} >
                        <BPMRequestProcedureType />
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalCancel} updateModal={setModalCancel} eventModal={() => { deleteProcedureImp() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <textarea rows={5} className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}